import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  getInquiryList(options, data, page) {
    const response = Api().post(apiPath.inquiry + "/list/" + page, data, options);
    return response;
  },

  changeStatus(options, data) {
    const response = Api().post(apiPath.inquiry + "/change_status", data, options);
    return response;
  }
};
